<div class="action-wrapper">
  <a
    class="view-button align-left foreground-jimmy flex"
    (click)="atButtonClicked()"
  >
    {{ text }}
    <mat-icon matPrefix class="" color=""> read_more </mat-icon>
  </a>
</div>
